import _ from 'lodash';

// helper function, returns beginning and end of long strings
function summarizeString(obj) {
  // small string
  if (obj.length < 10) return obj;
  let stringExport = [];
  for (let i = 0; i < obj.length; i++) {
    const end = obj.length - 4;
    // push only leading and trailing characters
    if (i < 5 || i > end) {
      stringExport.push(obj[i]);
    }
    if (i === 6) {
      // interior characters are omitted
      stringExport.push('...');
    }
  }
  stringExport = stringExport.join('');
  return stringExport;
}
// helper function
function summarizeNestedObj(obj) {
  if (typeof obj === 'string') {
    return summarizeString(obj);
  }
  if (_.isArray(obj)) {
    // empty array
    if (obj.length === 0) return '[]';
    // nonempty array
    return '[...]';
  }
  if (_.isObject(obj)) {
    const nestedKeys = Object.keys(obj);
    // empty object
    if (nestedKeys.length === 0) return '{}';
    // nonempty object
    return '{...}';
  }
  // if obj is neither object, array, or string, return it
  return obj;
}

export function summarizeObject(obj) {
  if (_.isArray(obj)) {
    if (obj.length === 0) {
      return '[]';
    }
    // array to be stringified and returned
    const arrayExport = [];
    // display 1st, 2nd, and last index
    for (let i = 0; i < obj.length; i++) {
      const end = obj.length - 1;
      if (i < 2 || i === end) {
        arrayExport.push(summarizeNestedObj(obj[i]));
      }
      if (i === 2 && i !== end) {
        // 'interior' indexes are omitted
        arrayExport.push('...');
      }
    }
    let arrayString = arrayExport.join(', ');
    arrayString = `[${arrayString}]`;
    return arrayString;
  }
  if (_.isObject(obj)) {
    // object to be stringified and returned
    let objExport = {};
    // sort keys into array and display first 3 pairs
    const objKeys = Object.keys(obj);
    objKeys.sort(); // sort keys into alpha order
    for (let i = 0; i < objKeys.length; i++) {
      // value in exported json is the summarized value of corresponding key in original json
      if (i < 3) {
        objExport[objKeys[i]] = summarizeNestedObj(obj[objKeys[i]]);
      }
      if (i > 2) {
        break;
      }
    }
    if (objKeys.length > 3) {
      objExport = JSON.stringify(objExport);
      objExport = objExport.substring(0, objExport.length - 1);
      objExport = objExport.concat(',...}');
    } else {
      objExport = JSON.stringify(objExport);
    }
    objExport = objExport.replace(/"{}"/g, '{}');
    objExport = objExport.replace(/"{...}"/g, '{...}');
    objExport = objExport.replace(/"\[\]"/g, '[]');
    objExport = objExport.replace(/"\[\.\.\.\]"/g, '[...]');
    objExport = objExport.replace(/"\u2026"/g, '...');
    return objExport;
  }
  // helper will return trimmed string if applicable
  return summarizeNestedObj(obj);
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function isLoggedIn() {
  await _.get(window, 'app.$store.state.users.loginComplete');
  return _.get(window, 'app.$store.getters["users/loggedIn"]', false);
}



// WEBPACK FOOTER //
// ./src/utilities.js